import { dispatchBlockReason, type ScenarioMaintenanceLike } from './robotDispatch'

/** Inputs shared by scenario list rows / launch pickers / editor banners. */
export type ScenarioReadinessFlags = {
  missions_statuses?: string[] | null
  missions_type_inconsistent?: boolean
  service_points_incomplete?: boolean
  robot_type?: string | null
  maintenance?: ScenarioMaintenanceLike
}

/**
 * Human-readable reasons why Launch / select is blocked (empty = launchable).
 * Pass `targetRobotType` when a robot is already chosen: station lots are
 * checked against that robot via the station↔robot-type map.
 */
export function getScenarioLaunchBlockReasons(
  scenario: ScenarioReadinessFlags,
  targetRobotType?: string | null
): string[] {
  const reasons: string[] = []
  const statuses = scenario.missions_statuses
  if (statuses != null) {
    if (statuses.length === 0) {
      reasons.push('Scenario has no missions')
    } else if (statuses.some(status => status !== 'ok')) {
      reasons.push('One or more missions are not calculated (status is not OK)')
    }
  }
  if (scenario.missions_type_inconsistent) {
    reasons.push('Missions have different robot types')
  }
  if (scenario.service_points_incomplete) {
    reasons.push('Service points have no selected actions')
  }
  const robotBlock = targetRobotType
    ? dispatchBlockReason({
        entityType: scenario.robot_type,
        robotType: targetRobotType,
        maintenance: scenario.maintenance,
      })
    : undefined
  if (robotBlock) reasons.push(robotBlock)
  return reasons
}

/** Native tooltip text (title=); undefined when ready to launch. */
export function getScenarioLaunchBlockReasonTitle(
  scenario: ScenarioReadinessFlags,
  targetRobotType?: string | null
): string | undefined {
  const reasons = getScenarioLaunchBlockReasons(scenario, targetRobotType)
  return reasons.length > 0 ? reasons.join('. ') : undefined
}
